module.exports = __webpack_public_path__ + "static/media/collection-bird-03.2f4eb155.png";